import * as React from 'react';
import propz from 'propz';
import moment from 'moment';
import { EventInvitationMessage } from 'Src/models/message';
import { SchoolEvent } from 'Src/models/event';

interface Props {
  item: EventInvitationMessage;
  event: SchoolEvent;
  activeSchoolId: string;
}

export const AvailabilityReportsDetails = (props: Props) => {
  const { item, event, activeSchoolId } = props;
  const details = propz.get(item, ['details'], '');
  const isTakePart = !!propz.get(item, ['isTakePart'], false);
  const isDetailsExist = details !== '';
  const detailsText = isDetailsExist ? details : 'Details are not specified';
  const generatedNames = propz.get(event, ['generatedNames']);
  const isGeneratedNamesExist = typeof generatedNames !== 'undefined' || generatedNames !== '';
  let eventName;

  if (isGeneratedNamesExist) {
    const schoolIdsFromGeneratedNames = Object.keys(generatedNames);
    const isActiveSchoolIdExistInGeneratedNames = schoolIdsFromGeneratedNames.includes(activeSchoolId);

    eventName = isActiveSchoolIdExistInGeneratedNames ? generatedNames[activeSchoolId] : generatedNames.official;
  } else {
    eventName = 'Event name not assigned';
  }

  const startTime = propz.get(event, ['startTime'], '');
  const endTime = propz.get(event, ['endTime'], '');
  const startTimeFormatted = moment(startTime).format('DD-MM-YYYY HH:mm');
  const endTimeFormatted = moment(endTime).format('DD-MM-YYYY HH:mm');

  return (
    <div className="parentDetailPanel">
      <div className="parentDetailPanel__intro"><span aria-hidden="true">A</span><div><h3>Availability report</h3><p>Your response and its related event.</p><span className={`parentDetailPanel__status ${isTakePart ? 'is-positive' : 'is-negative'}`}>{isTakePart ? 'Available' : 'Not available'}</span></div></div>
      <dl className="parentDetailPanel__list">
        <div><dt>Event</dt><dd>{eventName}</dd></div>
        <div><dt>Description</dt><dd>{detailsText}</dd></div>
        <div><dt>Starts</dt><dd>{startTimeFormatted}</dd></div>
        <div><dt>Ends</dt><dd>{endTimeFormatted}</dd></div>
      </dl>
    </div>
  );
};

AvailabilityReportsDetails.displayName = 'AvailabilityReportsDetails';



